module.exports = __webpack_public_path__ + "static/media/checkpoint-dark-logo.ecf18ce5.png";